import styled from "styled-components";

export const ModalBlock = styled.div`
    align-items: center;
    bottom: 0;
    justify-content: center;
    left: 0;
    overflow: hidden;
    padding: 0.4rem;
    position: fixed;
    right: 0;
    top: 0;
    display: flex;
    opacity: 1;
    z-index: 400;
`;

export const ModalOverlay = styled.a`
    background: rgba(247, 248, 249, 0.75);
    bottom: 0;
    cursor: default;
    display: block;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
`;

export const ModalClose = styled.a`
    float: right !important;
    text-decoration: none !important;
    cursor: pointer;

    font-size: 1.2vw;
    border: 1px solid black;
    height: 100%;
    line-height: 100%;
    text-align: center;
    padding: 0.5vw;
    margin-right: 1vw;

    @media (max-width: 800px) {
        font-size: 4.5vw;
    }
`;

export const ModalContainer = styled.div`
    background: #ffffff;
    border-radius: 0.1rem;
    display: flex;
    flex-direction: column;
    max-height: 85vh;
    max-width: 850px;
    width: 100%;
    animation: slide-down 0.2s ease 1;
    z-index: 1;
    box-shadow: 0 0.2rem 0.5rem rgba(48, 55, 66, 0.3);
`;

export const ModalBody = styled.div`
    overflow-y: auto;
    position: relative;
    min-height: 1vw;
    display: flex;
    justify-content: center;
    padding: 1vw;
`;

export const ModalHeader = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    color: #303742;
    padding: 20px 5px 10px 5px;
`;

export const ModalTitle = styled.span`
    font-size: 2vw;
    font-weight: 300;
    text-align: center;
    width: 100%;

    @media (max-width: 800px) {
        font-size: 5vw;
    }
`;

export const ModalFooter = styled.div`
    padding: 10px 0px;
    text-align: right;
`;

export const Button = styled.button`
    background: #7b2cbf;
    color: white;
    font-size: 1em;
    margin: 10px;
    padding: 5px 10px;
    border: 2px solid #7b2cbf;
    border-radius: 3px;
    cursor: pointer;
`;
